module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-5"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "para-first"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("any students, colleagues, and friends have assisted me in writing this book. I especially wish to thank those who read its early drafts in whole or in part and offered helpful comments: Cornelius Plantinga Jr., George S. Hendry, Hugh T. Kerr, Nancy Duff, Kathleen D. Billman, and Leanne Van Dyk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am also indebted to George Stroup, Michael Welker, Ellen Charry, Sang Hyun Lee, Mark Kline Taylor, and David E. Willis-Watkins, with each of whom at various times I taught the basic course in theology at Princeton Theological Seminary. Just how much their ideas enriched my own would be embarrassing to relate in detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am grateful to Presidents Thomas Gillespie and Iain Torrance, and to the Trustees of Princeton Theological Seminary for sabbatical leaves that enabled me to complete the several editions of the book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My gratitude to my wife Margaret (†2017) for her love and support as well as for her wise editorial advice is far greater than I can say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, I want to express my thanks to the many first-year MDiv students in TH01 who patiently listened to versions of some of the chapters. Their questions, suggestions, and encouragement were a constant source of strength and joy to me. To all these students this book is gratefully dedicated.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6426aae3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Ack.vue
// module id = 84
// module chunks = 0